export default __webpack_public_path__ + "static/media/icon_filter.6726bf9c.svg";